// extracted by mini-css-extract-plugin
export default {"hideXScroll":"_3ZH27ZiVmbZKdOIwG4zlZ7"};